import { ApplicationState } from '@/store';
import { useSelector } from 'react-redux';
import { ApplicationDrawerProps } from './types';
import { usedByAgent, usedByPartner, usedByUniStaff } from './utils';
import { AgentApplicationDrawer, PartnerApplicationDrawer, UniStaffApplicationDrawer } from './drawers';

export function ApplicationDrawer(props: ApplicationDrawerProps) {
  const role = useSelector((state: ApplicationState) => state.auth.role);

  if (usedByAgent(role)) {
    return <AgentApplicationDrawer {...props} />;
  }

  if (usedByPartner(role)) {
    return <PartnerApplicationDrawer {...props} />;
  }

  if (usedByUniStaff(role)) {
    return <UniStaffApplicationDrawer {...props} />;
  }

  return null;
}
